import { render, staticRenderFns } from "./AddMerchant.vue?vue&type=template&id=c0dcbd88&scoped=true"
import script from "./AddMerchant.vue?vue&type=script&lang=js"
export * from "./AddMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dcbd88",
  null
  
)

export default component.exports